﻿import {DriverId} from "../../nominalTypes/DriverId";
import {CreateDriverArguments} from "../../types/arguments/CreateDriverArguments";
import IPermitsDrivers from "../IPermitsDrivers";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsDrivers implements IPermitsDrivers {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	create(data: CreateDriverArguments, signal?: AbortSignal | undefined): Promise<DriverId> {
		return this._client.jsonFetch("drivers", "POST", data, {
			signal: signal
		});
	}
}
